
window.gantt = require("./core/gantt")();

require("./core/deprecated_warnings")(window.gantt);



//////////////////
// WEBPACK FOOTER
// ./sources/dhtmlxgantt.js
// module id = 20
// module chunks = 0